import { LocalUserChoices } from '@livekit/components-core'

export const preJoinDefaults: Partial<LocalUserChoices> = {
  username: '',
  videoEnabled: true,
  audioEnabled: true,
}
